import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { Tag } from "../../../model/tags";
import { Messages } from "../../../model/messages";
import { TagsService } from "../../../services/tags.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../../services/navigation.helper";
import { Navigation } from "../../../model/navigation";
import { ActionButtonSubmit } from "../../../model/action-button-submit";

@Component({
  selector: "tags-details",
  templateUrl: "./tags-details.component.html",
  styleUrls: ["./tags-details.component.css"],
})
export class TagsDetailsComponent implements OnInit {
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);
  tags = new BehaviorSubject<Tag>(new Tag(0, "", ""));
  editMode: boolean = false;
  tagsForm: FormGroup;
  tagTitle: string = "tagsDetails.title.tag.details";
  isLoading = false;
  constructor(
    private tagsService: TagsService,
    private auth: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private nav: NavigationHelper
  ) {}

  ngOnInit(): void {
    this.initializeForm();

    if (Navigation.NEW.toString() === this.nav.currentId) {
      this.editMode = true;
      this.tagsForm.reset();
      this.tagTitle = "tagsDetails.title.new.tag";
    }
    this.tagsService.selectedTagsObservable.subscribe((selectedTag) => {
      if (selectedTag) {
        this.populateForm(selectedTag);
      }
    });
    if (!(this.tagsService.currentTags && this.tagsService.currentTags.id)) {
      this.tagsService.selectFromRouter();
    }
  }

  private initializeForm(): void {
    this.tagsForm = this.fb.group({
      name: ["", [Validators.required, Validators.minLength(2)]],
      color: [""],
    });
  }

  private populateForm(tags: Tag): void {
    this.tags.next(tags);
    this.tagsForm.patchValue({
      id: tags.id,
      name: tags.value,
      color: tags.color,
    });
    this.editMode = tags.id === Navigation.NEW;
    this.tagTitle = this.editMode
      ? "tagDetails.title.new.tag"
      : "tagDetails.title";
  }
  toggleEditMode() {
    if (this.editMode) {
      this.editMode = false;
      this.tags.next(Tag.EMPTY);
      this.tagsForm.reset();
      this.tagTitle = "tagDetails.title";
    } else {
      this.editMode = true;
    }
  }

  saveTag(action: ActionButtonSubmit): void {
    this.isLoading = true;

    if (this.tagsForm.valid) {
      const token = this.auth.token;
      const id = this.tags.value.id;

      const updatedTag = new Tag(
        id === null || id < 1 ? null : id,
        this.tagsForm.value.name || "",
        this.tagsForm.value.color || ""
      );

      if (updatedTag.id === null || updatedTag.id < 1) {
        this.tagsService.createTags(token, updatedTag).subscribe(
          (messages) => {
            this.isLoading = false;
            this.messages.next(messages);

            if (messages.hasAnyMessages) {
              action.result(false);
            } else {
              this.updateTagsList(token);
              this.router.navigate(["tags"]);
              action.result(true);
            }
          },
          (error) => {
            this.isLoading = false;
            action.result(false);
            this.messages.next(
              Messages.from({ tags: ["tags.unknown.error", error] })
            );
          }
        );
      } else {
        this.tagsService.updateTags(token, updatedTag).subscribe(
          (messages) => {
            this.isLoading = false;
            this.messages.next(messages);

            if (messages.hasAnyMessages) {
              action.result(false);
            } else {
              this.updateTagsList(token);
              this.router.navigate(["tags"]);
              action.result(true);
            }
          },
          (error) => {
            this.isLoading = false;
            action.result(false);
            this.messages.next(
              Messages.from({ tags: ["tags.unknown.error", error] })
            );
          }
        );
      }
    } else {
      this.isLoading = false;
      action.result(false);

      this.messages.next(Messages.from({ tags: ["tags.form.invalid"] }));
    }
  }

  deleteTag(): void {
    const token = this.auth.token;
    const tagId = this.tags.value.id;

    if (tagId != null) {
      this.tagsService.deletetags(token, tagId).subscribe(
        (response) => {
          this.messages.next(response);
          this.updateTagsList(token);
          this.tags.next(Tag.EMPTY);
        },
        (error) => {
          this.messages.next(Messages.from({ tags: ["tag.delete.failed"] }));
        }
      );
    }
  }
  updateTagsList(token: string): void {
    this.tagsService.tags(token).subscribe((messages) => {
      const updatedTag = this.tagsService.tagsData;
      this.tagsService._currentTags.next(updatedTag);
    });
  }
}
